import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import PlaySolid from '@adv-mt/mt-svg-icons/lib/PlaySolid'

import {BASE_CLASS, SLIDER_IMAGE_DESIGNS} from '../../../config.js'
import GalleryBasicSliderImage from '../Image.js'

const Thumbnail = ({currentSlide, firstImage, index, onVideoPlay, sliderImageDesign}) => {
  return (
    <>
      <GalleryBasicSliderImage
        image={firstImage}
        sliderImageDesign={sliderImageDesign}
        index={index}
        currentSlide={currentSlide}
        hasSingleImage={false}
      />
      <div className={`${BASE_CLASS}-videoControl`}>
        <div className={`${BASE_CLASS}-videoControlPlay`}>
          <PlaySolid size={ATOM_ICON_SIZES.extraLarge} onClick={e => onVideoPlay(e)} />
        </div>
      </div>
    </>
  )
}

Thumbnail.propTypes = {
  currentSlide: PropTypes.number,
  firstImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    key: PropTypes.string,
    title: PropTypes.string,
    fetchpriority: PropTypes.string
  }).isRequired,
  index: PropTypes.string,
  onVideoPlay: PropTypes.func,
  sliderImageDesign: PropTypes.oneOf(Object.values(SLIDER_IMAGE_DESIGNS))
}

export default Thumbnail
